import React from "react";

const DropDownItem = ({ handleListClick, id, disabled, index, title }) => {
  const handleItemClick = () => {
    handleListClick(title, id, index);

  };
  return (
    <li
      id={`item-${id}`}
      className={`${disabled ? "prevent not-checked" : ""}`}
      onClick={handleItemClick}
    >
      {title}
    </li>
  );
};

export default DropDownItem;
